import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import BootstrapTable from 'react-bootstrap-table-next';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../subscriptions.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


class ViewPetshop extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (

    <div className="modal fade" id="view_petshop_modal" tabIndex="-1" role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Petshop Details</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="col-xl-12">
                        <div className="m-form__section m-form__section--first row">
                            <div className="col-lg-4" style={{alignItems:'center',display:'flex'}}>
                                <div className="row m--align-center">
                                    <div className="mx-auto my-0 col-sm-12">
                                        <img src="https://s3.amazonaws.com/uploads.development.petpos/uploads/4/logo/e20702d5a9a892aad6e4f0fe4cf605671539858350714.png" className="m-width-15rem" alt=""/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8">
                                <div className="m-widget4">
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-link mr-2"></i>
                                        <span><strong>Domain name: </strong></span>lakshanshop1.petpos.com</span>
                                    </div>
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-user mr-2"></i>
                                        <span><strong>Owner name: </strong></span>Lakshan Kasun</span>
                                    </div>
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub">
                                        <i className="fas fa-at mr-2"></i>
                                        <span><strong>Email: </strong></span>lakshan123+1@gmail.com</span>
                                    </div>
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub"><i className="fas fa-phone mr-2"></i>
                                        <span><strong>Phone Number: </strong></span>+94772000919</span>
                                    </div>
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub"><i className="fas fa-globe mr-2"></i>
                                        <span><strong>Country: </strong></span>sri lanka</span>
                                    </div>
                                    <div className="m-widget4__item">
                                        <span className="m-widget4__sub"><span>You have disapproved to receive our newsletter</span></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(ViewPetshop));